(function () {
  const sectionInstances = new WeakMap();

  class FeatureCardsSection {
    constructor(section) {
      this.layoutEl = section.querySelector(".feature-cards__layout");
      this.wrapper = this.layoutEl?.querySelector(".feature-cards__wrapper");

      if (!this.layoutEl || !this.wrapper) return;
      if (this.layoutEl.dataset.layout !== "slider") return;
      if (!this.wrapper.children.length) return;

      this.perRow = Number(this.layoutEl.dataset.cardsPerRow || 1);
      this.swiper = null;
      this.resizeObserver = null;

      this.initSwiper();
      this.bindResize();
    }

    // Mirrors the --per-row steps set in the section {% style %}.
    getCurrentCols() {
      const steps = [
        { bp: 0, cols: 1 },
        { bp: 750, cols: 2 },
        { bp: 1200, cols: 3 },
        { bp: 1536, cols: 4 },
      ].filter((step) => step.cols <= this.perRow);

      let cols = 1;
      steps.forEach((step) => {
        if (window.innerWidth >= step.bp) cols = step.cols;
      });

      return cols;
    }

    // The peek that hints at swipability is only reserved while the track overflows.
    updateOverflow() {
      const visibleCards = this.wrapper.querySelectorAll(
        ".feature-card"
      ).length;

      this.layoutEl.classList.toggle(
        "has-overflow",
        visibleCards > this.getCurrentCols()
      );
    }

    initSwiper() {
      // Mobile centers the intermediate slides, first/last stay flush to the edges.
      // Must be switched off explicitly at 750 — breakpoint params merge, they don't reset.
      this.swiper = new Swiper(this.layoutEl, {
        slidesPerView: "auto",
        touchEventsTarget: "container",
        spaceBetween: 16,
        speed: 1000,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        mousewheel: {
          forceToAxis: true,
        },
        breakpoints: {
          750: {
            spaceBetween: 24,
            centeredSlides: false,
            centeredSlidesBounds: false,
          },
        },
        on: {
          init: () => this.updateOverflow(),
          resize: () => this.updateOverflow(),
        },
      });
    }

    bindResize() {
      if (typeof ResizeObserver === "undefined") return;

      this.resizeObserver = new ResizeObserver(() => {
        if (!this.swiper) return;
        this.swiper.update();
        this.updateOverflow();
      });

      this.resizeObserver.observe(this.layoutEl);
    }

    destroy() {
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;

      const swiperInstance = this.swiper || this.layoutEl?.swiper;
      if (typeof swiperInstance?.destroy === "function") {
        swiperInstance.destroy(true, true);
      }
      this.swiper = null;
    }
  }

  const destroyFeatureCardsSection = (section) => {
    if (!section || !section.classList.contains("feature-cards-section"))
      return;

    const instance = sectionInstances.get(section);
    if (!instance) return;

    instance.destroy();
    sectionInstances.delete(section);
  };

  const initFeatureCardsSection = (section) => {
    if (!section || !section.classList.contains("feature-cards-section"))
      return;

    destroyFeatureCardsSection(section);
    sectionInstances.set(section, new FeatureCardsSection(section));
  };

  initFeatureCardsSection(document.currentScript.parentElement);

  if (!window.__themeFeatureCardsEvents) {
    window.__themeFeatureCardsEvents = true;

    document.addEventListener("shopify:section:load", function (event) {
      initFeatureCardsSection(event.target);
    });

    document.addEventListener("shopify:section:unload", function (event) {
      destroyFeatureCardsSection(event.target);
    });
  }
})();
